<template>
    <client-page>
        <sub-visual tit="개인정보 취급방침" sc="개인정보 취급방침 내용이 들어갑니다." bg="/images/sub/visual/sv-privacy.jpg" />
        <section class="section">
            <v-container>
                <terms-component code="privacy" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TermsComponent from "@/components/client/terms/terms-component.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";

export default {
    components: {
        SubVisual,
        ClientPage,
        TermsComponent,
    },
};
</script>
